
<div class="quantity_header">{{'startOrder.quantitypopuphead' | cxTranslate}}</div>

<mat-dialog-content class="quantity_content">{{'startOrder.quantitycontent' | cxTranslate}}
</mat-dialog-content>


<mat-dialog-content class="productbox">
  <!-- <ng-container *ngFor="let productlist of prebookproductlist">
  <ng-container  *ngFor="let productqty of productdata">

    <div class="productlist" *ngIf="productlist.code==productqty.productCode">
      <div>
        <div class="productname">{{productlist.baseName}}</div>
        <div class="productpresent">{{productlist.presentationName}}</div>
      </div>
      <div>
        <div *ngFor="let productdata of productqty.shipLocationQty">
          <div class="original">Original Quantity: {{productdata?.locQty}}</div>
          <div class="increase">Updated Quantity: {{productdata?.increaseqty}}</div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container> -->
@for (ship of prebookproductlist[0].location; track ship) {
  <div class="locationname">{{ship.address}}</div>
  @for (productlist of prebookproductlist; track productlist) {
    @for (productqty of productdata; track productqty) {
      @if (productlist.code==productqty.productCode) {
        <div class="productlist">
          <div>
            <div class="productname">{{productlist.baseName}}</div>
            <div class="productpresent">{{productlist.presentationName}}</div>
          </div>
          <div>
            @for (productdata of productqty.shipLocationQty; track productdata) {
              <div>
                @if (ship.locID==productdata.locID) {
                  <div class="original">Original Quantity: {{productdata?.locQty}}</div>
                  <div class="increase">Updated Quantity: {{productdata?.increaseqty}}</div>
                }
              </div>
            }
          </div>
        </div>
      }
    }
  }
}
</mat-dialog-content>

<mat-dialog-actions class="no-padding" align="center">
  <button mat-button class="updatebtn" (click)="close(true)">{{'startOrder.quantityupdate' | cxTranslate}}</button>
</mat-dialog-actions>
<mat-dialog-actions class="no-padding notext" align="center">
  <button mat-button class="keepcurrent" (click)="close(false)">{{'startOrder.quantitynothanks' | cxTranslate}}</button>
</mat-dialog-actions>




